import { classNames, formatCurrency } from "helpers";
import {
  ExpenseGroupRowProps,
  ExpenseLeafRowProps,
  ShareBarProps,
} from "./types";

/** Širina trake jedina je dinamička vrijednost, pa ide inline. */
const ShareBar: React.FC<ShareBarProps> = ({ percent, strong }) => (
  <div className="h-1.5 w-24 rounded-full bg-slate-100 overflow-hidden">
    <div
      className={classNames("h-full rounded-full", strong ? "bg-sky-500" : "bg-sky-300")}
      style={{ width: `${Math.min(percent, 100)}%` }}
    />
  </div>
);

const ExpenseLeafRow: React.FC<ExpenseLeafRowProps> = ({ node }) => (
  <div className="flex items-center gap-3 px-4 py-2 pl-10 border-t border-slate-50">
    <div className="flex-1 min-w-0 text-sm text-slate-600 truncate">{node.name}</div>
    <div className="w-16 text-right text-xs text-slate-400">{node.count}</div>
    <div className="w-32 text-right text-sm text-slate-700">
      {formatCurrency.format(node.amount)}
    </div>
    <div className="w-16 text-right text-xs text-slate-500">
      {node.sharePercent.toFixed(1)} %
    </div>
    <ShareBar percent={node.sharePercent} />
  </div>
);

const ExpenseGroupRow: React.FC<ExpenseGroupRowProps> = ({ node, isOpen, onToggle }) => {
  const handleToggle = () => onToggle(node.name);

  return (
    <div className="border-t border-slate-100 first:border-t-0">
      <div
        onClick={handleToggle}
        className="flex items-center gap-3 px-4 py-2.5 cursor-pointer hover:bg-slate-50"
      >
        <span className="w-4 text-xs text-slate-400">
          {node.children.length > 0 ? (isOpen ? "▾" : "▸") : ""}
        </span>
        <div className="flex-1 min-w-0 text-sm font-semibold text-slate-800 truncate">
          {node.name}
        </div>
        <div className="w-16 text-right text-xs text-slate-400">{node.count}</div>
        <div className="w-32 text-right text-sm font-semibold text-slate-800">
          {formatCurrency.format(node.amount)}
        </div>
        <div className="w-16 text-right text-xs text-slate-600">
          {node.sharePercent.toFixed(1)} %
        </div>
        <ShareBar percent={node.sharePercent} strong />
      </div>
      {isOpen &&
        node.children.map((child) => <ExpenseLeafRow key={child.name} node={child} />)}
    </div>
  );
};

export default ExpenseGroupRow;
